import makeStyles from "@material-ui/core/styles/makeStyles"

export const useBeautyModalStyle = makeStyles({
    root: {
        position: "absolute",
        width: "100%",
        height: "100%",
    },
    timeBlock: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginTop: 20,
    },
    input: {
        width: "100%",
        marginTop: 10,
    },
    materialBtn: {
        display: "flex",
        justifyItems: "flex-start",
        alignItems: "center",
        marginTop: 20,
        marginLeft: -5,
    },
})
